<template>
    <el-date-picker v-bind="myProps"
					v-model="dateRange"
					@change="handleChange"/>
</template>

<script>
	import {typeOf,isDef} from "@utils/linktools";

	export default {
        name: "lnk-daterange-picker",
        data(){
            return{
                dateRange: []
            };
        },
        props: {
        	value: Object,
			/*开始时间*/
			start: String,
			/*结束时间*/
			end: String,
			/*样式名*/
			classname: String,
			/*属性映射*/
			propMapping: {
				type: Array,
				default: [0, 1]
			}
        },
        watch: {
			startEndKey(val) {
				if(this.rangeKey === val) return;
				this.setRangeFromStartEnd();
            },
			valueKey(val){
				if(this.rangeKey === val) return;
				this.setRangeFromValue();
			}
        },
		computed: {
        	myProps(){
        		const props = {...this.$attrs};
				props.class = [props.class, this.classname || ''];
				props.type = props.type || 'daterange'
				props.size = props.size || 'mini'
        		return props;
			},
			myMap(){
				return Array.isArray(this.propMapping) && this.propMapping.length === 2 ? this.propMapping : [0, 1];
			},
			rangeKey(){
				const range = this.dateRange || [];
				return `${range[0] || ''}-${range[1] || ''}`;
			},
			startEndKey(){
        		return `${this.start || ''}-${this.end || ''}`;
			},
			valueKey(){
				const value = this.value || [];
				return Array.isArray(value)
					? `${value[0] || ''}-${value[1] || ''}`
					: `${value[this.myMap[0]] || ''}-${value[this.myMap[1]] || ''}`;
			}
		},
        methods: {
            handleChange(val){
            	val = val || [];
            	if(!isDef(this.value)
					|| typeof this.value !== 'object'
					|| Array.isArray(this.value)){
					this.$emit('input', val);
				}else if(typeof this.value === 'object'){
					this.myMap.forEach((k,i)=> this.$set(this.value, k, val[i] || null));
				}
				this.$emit('update:start', val[0] || null);
				this.$emit('update:end', val[1] || null);
				this.$emit('change', val);
            },
			setRangeFromValue(){
				const value = this.value || [];
				const values = Array.isArray(this.value)
					? [...value]
					: this.myMap.map((k)=> value[k]);
				this.dateRange = values.filter((v)=> isDef(v));
			},
			setRangeFromStartEnd(){
				const values = [this.start, this.end];
				this.dateRange = values.filter((v)=> isDef(v));
			}
        },
		created() {
        	if(this.value) this.setRangeFromValue();
        	if(this.start && this.end) this.setRangeFromStartEnd();
		}
	}
</script>

<style scoped>

</style>
